export const currencyDonationAmount = (amount, isZeroDecimal) =>
  isZeroDecimal ? parseInt(amount) : parseInt(parseFloat(amount) * 100)
